import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SfXmarkIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M1.306 22.694a1.096 1.096 0 0 0 1.51 0l9.168-9.179 9.179 9.18c.402.401 1.097.412 1.499 0 .413-.424.413-1.098 0-1.5l-9.168-9.179 9.168-9.179a1.052 1.052 0 0 0 0-1.499c-.413-.402-1.097-.402-1.5 0l-9.178 9.18-9.169-9.18c-.412-.402-1.097-.413-1.51 0-.401.424-.401 1.097 0 1.5l9.18 9.178-9.18 9.18a1.072 1.072 0 0 0 0 1.498Z"
  })
});
export default SfXmarkIcon;